// Panel
import SidePanel from "./panel";

// Helpers
import type { DialerInstance } from "src/services/dialer";

import FloatDialer from "src/pages/main/components/aside/float-dialer";

export default function PanelDialer({ togglePanel, dialer, fullHeight = false }: { fullHeight?: boolean; togglePanel: Function; dialer?: DialerInstance }) {
  if (!dialer) {
    alert("Sem instancia discador para continuar.");

    return null;
  }

  return (
    <SidePanel panelName="Discador" toggleAction={togglePanel} className={`dialer ${fullHeight ? "" : "absolute right-0 bottom-0"} flex flex-col z-10 bg-white max-h-full`}>
      <FloatDialer dialer={dialer} />
    </SidePanel>
  );
}
